module.exports = __webpack_public_path__ + "img/cover.1cb813c0.jpg";